module.exports = __webpack_public_path__ + "img/blog-1-1.f83babe9.webp";